/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/custom-elements';

import { defineCustomElement as defineOsdsAccordion } from '@ovhcloud/ods-stencil/components/custom-elements/osds-accordion.js';
import { defineCustomElement as defineOsdsAccordionGroup } from '@ovhcloud/ods-stencil/components/custom-elements/osds-accordion-group.js';
import { defineCustomElement as defineOsdsBreadcrumb } from '@ovhcloud/ods-stencil/components/custom-elements/osds-breadcrumb.js';
import { defineCustomElement as defineOsdsBreadcrumbItem } from '@ovhcloud/ods-stencil/components/custom-elements/osds-breadcrumb-item.js';
import { defineCustomElement as defineOsdsButton } from '@ovhcloud/ods-stencil/components/custom-elements/osds-button.js';
import { defineCustomElement as defineOsdsCart } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart.js';
import { defineCustomElement as defineOsdsCartFooter } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-footer.js';
import { defineCustomElement as defineOsdsCartFooterItem } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-footer-item.js';
import { defineCustomElement as defineOsdsCartHeader } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-header.js';
import { defineCustomElement as defineOsdsCartItem } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-item.js';
import { defineCustomElement as defineOsdsCartItemOption } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-item-option.js';
import { defineCustomElement as defineOsdsCartManager } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-manager.js';
import { defineCustomElement as defineOsdsCartSection } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-section.js';
import { defineCustomElement as defineOsdsCartTotal } from '@ovhcloud/ods-stencil/components/custom-elements/osds-cart-total.js';
import { defineCustomElement as defineOsdsCheckbox } from '@ovhcloud/ods-stencil/components/custom-elements/osds-checkbox.js';
import { defineCustomElement as defineOsdsCheckboxButton } from '@ovhcloud/ods-stencil/components/custom-elements/osds-checkbox-button.js';
import { defineCustomElement as defineOsdsChip } from '@ovhcloud/ods-stencil/components/custom-elements/osds-chip.js';
import { defineCustomElement as defineOsdsCode } from '@ovhcloud/ods-stencil/components/custom-elements/osds-code.js';
import { defineCustomElement as defineOsdsCollapsible } from '@ovhcloud/ods-stencil/components/custom-elements/osds-collapsible.js';
import { defineCustomElement as defineOsdsContentAddon } from '@ovhcloud/ods-stencil/components/custom-elements/osds-content-addon.js';
import { defineCustomElement as defineOsdsDivider } from '@ovhcloud/ods-stencil/components/custom-elements/osds-divider.js';
import { defineCustomElement as defineOsdsFlag } from '@ovhcloud/ods-stencil/components/custom-elements/osds-flag.js';
import { defineCustomElement as defineOsdsIcon } from '@ovhcloud/ods-stencil/components/custom-elements/osds-icon.js';
import { defineCustomElement as defineOsdsInput } from '@ovhcloud/ods-stencil/components/custom-elements/osds-input.js';
import { defineCustomElement as defineOsdsLink } from '@ovhcloud/ods-stencil/components/custom-elements/osds-link.js';
import { defineCustomElement as defineOsdsLocationTile } from '@ovhcloud/ods-stencil/components/custom-elements/osds-location-tile.js';
import { defineCustomElement as defineOsdsMessage } from '@ovhcloud/ods-stencil/components/custom-elements/osds-message.js';
import { defineCustomElement as defineOsdsPagination } from '@ovhcloud/ods-stencil/components/custom-elements/osds-pagination.js';
import { defineCustomElement as defineOsdsPopover } from '@ovhcloud/ods-stencil/components/custom-elements/osds-popover.js';
import { defineCustomElement as defineOsdsPopoverContent } from '@ovhcloud/ods-stencil/components/custom-elements/osds-popover-content.js';
import { defineCustomElement as defineOsdsProgressBar } from '@ovhcloud/ods-stencil/components/custom-elements/osds-progress-bar.js';
import { defineCustomElement as defineOsdsQuantity } from '@ovhcloud/ods-stencil/components/custom-elements/osds-quantity.js';
import { defineCustomElement as defineOsdsRadio } from '@ovhcloud/ods-stencil/components/custom-elements/osds-radio.js';
import { defineCustomElement as defineOsdsRadioButton } from '@ovhcloud/ods-stencil/components/custom-elements/osds-radio-button.js';
import { defineCustomElement as defineOsdsRadioGroup } from '@ovhcloud/ods-stencil/components/custom-elements/osds-radio-group.js';
import { defineCustomElement as defineOsdsRange } from '@ovhcloud/ods-stencil/components/custom-elements/osds-range.js';
import { defineCustomElement as defineOsdsSelect } from '@ovhcloud/ods-stencil/components/custom-elements/osds-select.js';
import { defineCustomElement as defineOsdsSelectGroup } from '@ovhcloud/ods-stencil/components/custom-elements/osds-select-group.js';
import { defineCustomElement as defineOsdsSelectOption } from '@ovhcloud/ods-stencil/components/custom-elements/osds-select-option.js';
import { defineCustomElement as defineOsdsSkeleton } from '@ovhcloud/ods-stencil/components/custom-elements/osds-skeleton.js';
import { defineCustomElement as defineOsdsSpinner } from '@ovhcloud/ods-stencil/components/custom-elements/osds-spinner.js';
import { defineCustomElement as defineOsdsSwitch } from '@ovhcloud/ods-stencil/components/custom-elements/osds-switch.js';
import { defineCustomElement as defineOsdsSwitchItem } from '@ovhcloud/ods-stencil/components/custom-elements/osds-switch-item.js';
import { defineCustomElement as defineOsdsTabBar } from '@ovhcloud/ods-stencil/components/custom-elements/osds-tab-bar.js';
import { defineCustomElement as defineOsdsTabBarItem } from '@ovhcloud/ods-stencil/components/custom-elements/osds-tab-bar-item.js';
import { defineCustomElement as defineOsdsTabPanel } from '@ovhcloud/ods-stencil/components/custom-elements/osds-tab-panel.js';
import { defineCustomElement as defineOsdsTabs } from '@ovhcloud/ods-stencil/components/custom-elements/osds-tabs.js';
import { defineCustomElement as defineOsdsTile } from '@ovhcloud/ods-stencil/components/custom-elements/osds-tile.js';
import { defineCustomElement as defineOsdsToggle } from '@ovhcloud/ods-stencil/components/custom-elements/osds-toggle.js';
import { defineCustomElement as defineOsdsTooltip } from '@ovhcloud/ods-stencil/components/custom-elements/osds-tooltip.js';
import { defineCustomElement as defineOsdsTooltipContent } from '@ovhcloud/ods-stencil/components/custom-elements/osds-tooltip-content.js';


export const OsdsAccordion = /*@__PURE__*/ defineContainer<JSX.OsdsAccordion>('osds-accordion', defineOsdsAccordion, [
  'color',
  'contrasted',
  'size',
  'disabled',
  'opened',
  'odsAccordionToggle'
]);


export const OsdsAccordionGroup = /*@__PURE__*/ defineContainer<JSX.OsdsAccordionGroup>('osds-accordion-group', defineOsdsAccordionGroup);


export const OsdsBreadcrumb = /*@__PURE__*/ defineContainer<JSX.OsdsBreadcrumb>('osds-breadcrumb', defineOsdsBreadcrumb, [
  'contrasted',
  'items'
]);


export const OsdsBreadcrumbItem = /*@__PURE__*/ defineContainer<JSX.OsdsBreadcrumbItem>('osds-breadcrumb-item', defineOsdsBreadcrumbItem, [
  'contrasted',
  'isCollapsed',
  'isExpandableItem',
  'isLast',
  'href',
  'icon',
  'label',
  'odsBreadcrumbItemCollapsedClick'
]);


export const OsdsButton = /*@__PURE__*/ defineContainer<JSX.OsdsButton>('osds-button', defineOsdsButton, [
  'color',
  'contrasted',
  'disabled',
  'download',
  'flex',
  'href',
  'rel',
  'size',
  'target',
  'type',
  'variant',
  'circle'
]);


export const OsdsCart = /*@__PURE__*/ defineContainer<JSX.OsdsCart>('osds-cart', defineOsdsCart, [
  'size',
  'flex',
  'rounded',
  'collapsed',
  'collapsible'
]);


export const OsdsCartFooter = /*@__PURE__*/ defineContainer<JSX.OsdsCartFooter>('osds-cart-footer', defineOsdsCartFooter);


export const OsdsCartFooterItem = /*@__PURE__*/ defineContainer<JSX.OsdsCartFooterItem>('osds-cart-footer-item', defineOsdsCartFooterItem);


export const OsdsCartHeader = /*@__PURE__*/ defineContainer<JSX.OsdsCartHeader>('osds-cart-header', defineOsdsCartHeader, [
  'headerTitle'
]);


export const OsdsCartItem = /*@__PURE__*/ defineContainer<JSX.OsdsCartItem>('osds-cart-item', defineOsdsCartItem);


export const OsdsCartItemOption = /*@__PURE__*/ defineContainer<JSX.OsdsCartItemOption>('osds-cart-item-option', defineOsdsCartItemOption);


export const OsdsCartManager = /*@__PURE__*/ defineContainer<JSX.OsdsCartManager>('osds-cart-manager', defineOsdsCartManager, [
  'size',
  'flex',
  'sections',
  'footer',
  'vatMode',
  'period',
  'i18n'
]);


export const OsdsCartSection = /*@__PURE__*/ defineContainer<JSX.OsdsCartSection>('osds-cart-section', defineOsdsCartSection);


export const OsdsCartTotal = /*@__PURE__*/ defineContainer<JSX.OsdsCartTotal>('osds-cart-total', defineOsdsCartTotal);


export const OsdsCheckbox = /*@__PURE__*/ defineContainer<JSX.OsdsCheckbox>('osds-checkbox', defineOsdsCheckbox, [
  'afterSave',
  'ariaLabel',
  'ariaLabelledby',
  'beforeSave',
  'checked',
  'disabled',
  'hasFocus',
  'label',
  'name',
  'save',
  'updating',
  'value',
  'odsBlur',
  'odsCheckedChange',
  'odsFocus',
  'odsUpdatingChange'
]);


export const OsdsCheckboxButton = /*@__PURE__*/ defineContainer<JSX.OsdsCheckboxButton>('osds-checkbox-button', defineOsdsCheckboxButton, [
  'checked',
  'checking',
  'color',
  'disabled',
  'hasFocus',
  'indeterminate',
  'interactive',
  'size'
]);


export const OsdsChip = /*@__PURE__*/ defineContainer<JSX.OsdsChip>('osds-chip', defineOsdsChip, [
  'color',
  'contrasted',
  'disabled',
  'flex',
  'removable',
  'selectable',
  'size',
  'variant'
]);


export const OsdsCode = /*@__PURE__*/ defineContainer<JSX.OsdsCode>('osds-code', defineOsdsCode, [
  'color',
  'contrasted',
  'size',
  'odsCodeCopy'
]);


export const OsdsCollapsible = /*@__PURE__*/ defineContainer<JSX.OsdsCollapsible>('osds-collapsible', defineOsdsCollapsible, [
  'opened',
  'odsCollapsibleToggle'
]);


export const OsdsContentAddon = /*@__PURE__*/ defineContainer<JSX.OsdsContentAddon>('osds-content-addon', defineOsdsContentAddon);


export const OsdsDivider = /*@__PURE__*/ defineContainer<JSX.OsdsDivider>('osds-divider', defineOsdsDivider, [
  'separator',
  'color',
  'size',
  'contrasted'
]);


export const OsdsFlag = /*@__PURE__*/ defineContainer<JSX.OsdsFlag>('osds-flag', defineOsdsFlag, [
  'assetPath',
  'iso',
  'lazy',
  'src'
]);


export const OsdsIcon = /*@__PURE__*/ defineContainer<JSX.OsdsIcon>('osds-icon', defineOsdsIcon, [
  'ariaName',
  'color',
  'contrasted',
  'hoverable',
  'name',
  'size'
]);


export const OsdsInput = /*@__PURE__*/ defineContainer<JSX.OsdsInput>('osds-input', defineOsdsInput, [
  'ariaLabel',
  'ariaLabelledby',
  'clearable',
  'color',
  'contrasted',
  'defaultValue',
  'disabled',
  'error',
  'errorStateControl',
  'flex',
  'forbiddenValues',
  'formControl',
  'icon',
  'label',
  'loading',
  'masked',
  'max',
  'min',
  'name',
  'placeholder',
  'readOnly',
  'required',
  'size',
  'step',
  'type',
  'value',
  'odsValueChange',
  'odsInputBlur',
  'odsInputFocus'
]);


export const OsdsLink = /*@__PURE__*/ defineContainer<JSX.OsdsLink>('osds-link', defineOsdsLink, [
  'color',
  'contrasted',
  'disabled',
  'download',
  'href',
  'referrerpolicy',
  'rel',
  'target',
  'type'
]);


export const OsdsLocationTile = /*@__PURE__*/ defineContainer<JSX.OsdsLocationTile>('osds-location-tile', defineOsdsLocationTile, [
  'color',
  'disabled',
  'flex',
  'iso',
  'interactive',
  'checking',
  'checked',
  'size',
  'variant',
  'hasFocus'
]);


export const OsdsMessage = /*@__PURE__*/ defineContainer<JSX.OsdsMessage>('osds-message', defineOsdsMessage, [
  'color',
  'flex',
  'icon',
  'removable',
  'type',
  'contrasted',
  'odsRemoveClick'
]);


export const OsdsPagination = /*@__PURE__*/ defineContainer<JSX.OsdsPagination>('osds-pagination', defineOsdsPagination, [
  'current',
  'totalItems',
  'totalPages',
  'disabled',
  'labelTooltipPrevious',
  'labelTooltipNext',
  'odsPaginationChanged'
]);


export const OsdsPopover = /*@__PURE__*/ defineContainer<JSX.OsdsPopover>('osds-popover', defineOsdsPopover);


export const OsdsPopoverContent = /*@__PURE__*/ defineContainer<JSX.OsdsPopoverContent>('osds-popover-content', defineOsdsPopoverContent);


export const OsdsProgressBar = /*@__PURE__*/ defineContainer<JSX.OsdsProgressBar>('osds-progress-bar', defineOsdsProgressBar, [
  'max',
  'value'
]);


export const OsdsQuantity = /*@__PURE__*/ defineContainer<JSX.OsdsQuantity>('osds-quantity', defineOsdsQuantity, [
  'disabled'
]);


export const OsdsRadio = /*@__PURE__*/ defineContainer<JSX.OsdsRadio>('osds-radio', defineOsdsRadio, [
  'ariaLabel',
  'ariaLabelledby',
  'save',
  'beforeSave',
  'afterSave',
  'checked',
  'checking',
  'disabled',
  'label',
  'name',
  'value',
  'odsValueChange',
  'odsCheckedChange',
  'odsCheckingChange',
  'odsFocus',
  'odsBlur'
]);


export const OsdsRadioButton = /*@__PURE__*/ defineContainer<JSX.OsdsRadioButton>('osds-radio-button', defineOsdsRadioButton, [
  'checked',
  'checking',
  'color',
  'disabled',
  'hasFocus',
  'interactive',
  'size'
]);


export const OsdsRadioGroup = /*@__PURE__*/ defineContainer<JSX.OsdsRadioGroup>('osds-radio-group', defineOsdsRadioGroup, [
  'name',
  'value',
  'disabled',
  'save',
  'beforeSave',
  'afterSave',
  'required',
  'odsValueChange',
  'odsDisabledChange'
]);


export const OsdsRange = /*@__PURE__*/ defineContainer<JSX.OsdsRange>('osds-range', defineOsdsRange, [
  'color',
  'disabled',
  'flex',
  'max',
  'min',
  'step',
  'value',
  'formControl',
  'errorStateControl',
  'error',
  'forbiddenValues',
  'odsValueChange'
]);


export const OsdsSelect = /*@__PURE__*/ defineContainer<JSX.OsdsSelect>('osds-select', defineOsdsSelect, [
  'opened',
  'ariaLabel',
  'ariaLabelledby',
  'color',
  'defaultValue',
  'disabled',
  'flex',
  'required',
  'size',
  'value',
  'odsValueChange',
  'odsFocus',
  'odsBlur'
]);


export const OsdsSelectGroup = /*@__PURE__*/ defineContainer<JSX.OsdsSelectGroup>('osds-select-group', defineOsdsSelectGroup);


export const OsdsSelectOption = /*@__PURE__*/ defineContainer<JSX.OsdsSelectOption>('osds-select-option', defineOsdsSelectOption, [
  'selected',
  'value',
  'odsSelectOptionClick'
]);


export const OsdsSkeleton = /*@__PURE__*/ defineContainer<JSX.OsdsSkeleton>('osds-skeleton', defineOsdsSkeleton, [
  'flex',
  'randomized',
  'size'
]);


export const OsdsSpinner = /*@__PURE__*/ defineContainer<JSX.OsdsSpinner>('osds-spinner', defineOsdsSpinner, [
  'contrasted',
  'flex',
  'mode',
  'size'
]);


export const OsdsSwitch = /*@__PURE__*/ defineContainer<JSX.OsdsSwitch>('osds-switch', defineOsdsSwitch, [
  'color',
  'disabled',
  'contrasted',
  'variant',
  'size',
  'odsSwitchChanged'
]);


export const OsdsSwitchItem = /*@__PURE__*/ defineContainer<JSX.OsdsSwitchItem>('osds-switch-item', defineOsdsSwitchItem, [
  'value',
  'checked'
]);


export const OsdsTabBar = /*@__PURE__*/ defineContainer<JSX.OsdsTabBar>('osds-tab-bar', defineOsdsTabBar);


export const OsdsTabBarItem = /*@__PURE__*/ defineContainer<JSX.OsdsTabBarItem>('osds-tab-bar-item', defineOsdsTabBarItem, [
  'panel',
  'active',
  'disabled',
  'contrasted',
  'odsTabItemSelectEvent'
]);


export const OsdsTabPanel = /*@__PURE__*/ defineContainer<JSX.OsdsTabPanel>('osds-tab-panel', defineOsdsTabPanel, [
  'active',
  'name'
]);


export const OsdsTabs = /*@__PURE__*/ defineContainer<JSX.OsdsTabs>('osds-tabs', defineOsdsTabs, [
  'contrasted',
  'panel',
  'size',
  'odsTabsChanged'
]);


export const OsdsTile = /*@__PURE__*/ defineContainer<JSX.OsdsTile>('osds-tile', defineOsdsTile, [
  'hasFocus',
  'color',
  'disabled',
  'flex',
  'rounded',
  'hoverable',
  'loading',
  'checking',
  'checked',
  'size',
  'variant'
]);


export const OsdsToggle = /*@__PURE__*/ defineContainer<JSX.OsdsToggle>('osds-toggle', defineOsdsToggle, [
  'contrasted',
  'checked',
  'checking',
  'color',
  'disabled',
  'interactive'
]);


export const OsdsTooltip = /*@__PURE__*/ defineContainer<JSX.OsdsTooltip>('osds-tooltip', defineOsdsTooltip, [
  'variant'
]);


export const OsdsTooltipContent = /*@__PURE__*/ defineContainer<JSX.OsdsTooltipContent>('osds-tooltip-content', defineOsdsTooltipContent);

